import { cents } from './transactionSelection';

export function activityItems(transactions) {
  const items = new Map();
  for (const row of transactions) {
    const event = row.split_activity;
    const key = event?.key || `row:${row.id}`;
    const item = items.get(key) || { key, event, transaction: row, transaction_date: event?.transaction_date || row.transaction_date,
      label: event?.label || row.description || 'Transaction', amount: event?.amount || row.amount, matchedAmount: 0n, matchedCount: 0, giftCount: 0, order: items.size };
    if (row.user_label === 'gift') item.giftCount += 1;
    item.matchedAmount += cents(row.amount); item.matchedCount += 1; items.set(key, item);
  }
  return [...items.values()].sort((a, b) => b.transaction_date.localeCompare(a.transaction_date) || a.order - b.order);
}

export function allocationComparison(preview) {
  const groups = new Map();
  for (const side of ['before', 'after']) for (const row of preview[side]) {
    const key = row.category_id ?? 'none';
    const item = groups.get(key) || { key, name: row.category_name || 'No category', before: 0n, after: 0n };
    item[side] += cents(row.amount); groups.set(key, item);
  }
  return [...groups.values()];
}
